/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetGroupName$Request {
    requestBody: Array<number>;
}

export interface GetGroupName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGroupNameRequest = createAction<PayloadData<void, GetGroupName$Request>>('GET_GROUP_NAME__GET_GROUP_NAME__REQUEST');
export const getGroupNameSuccess = createAction<PayloadData<{ [key: string]: string; }, GetGroupName$Request>>('GET_GROUP_NAME__GET_GROUP_NAME__SUCCESS');
export const getGroupNameFailure = createAction<PayloadData<Error, GetGroupName$Request, true>>('GET_GROUP_NAME__GET_GROUP_NAME__FAILURE');

export const getGroupNameActions = [
    getGroupNameRequest,
    getGroupNameSuccess,
    getGroupNameFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGroupName = (meta: GetGroupName$Request, config?: GetGroupName$Config) => {
    return {
        CALL_API: {
            types: getGroupNameActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/groups/name`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

